import {Coordinate} from "ol/coordinate";
import {Extent} from "ol/extent";

export type Filter = {
  zoom?: number;
  center?: Coordinate;
  extent?: Extent;
  checkboxes: { [name: string]: string[]; },
  inputs: { [name: string]: string; }
}

export class FiltersHandler {
  onFilterChangedListener: (filter: Filter) => void;

  filter: Filter = {
    checkboxes: {},
    inputs: {}
  }

  constructor(onFilterChangedListener: (filter: Filter) => void) {
    this.onFilterChangedListener = onFilterChangedListener;
  }

  initialize = () => {
    const mobile = window.matchMedia("(max-width: 768px)").matches;
    const checkboxes = document.querySelectorAll<HTMLInputElement>(
      mobile ? "[data-public--map--modal-filter-target='checkbox']" : "[data-public--map--sidebar-filter-target='checkbox']"
    );

    const inputs = document.querySelectorAll<HTMLInputElement>(
      mobile ? "[data-public--map--modal-filter-target='input']" : "[data-public--map--sidebar-filter-target='input']"
    );

    for (const checkbox of checkboxes) {
      if (checkbox.checked) {
        if (!this.filter.checkboxes[checkbox.name]) {
          this.filter.checkboxes[checkbox.name] = [];
        }

        this.filter.checkboxes[checkbox.name].push(checkbox.value);
      }
    }

    for (const input of inputs) {
      if (input.value) {
        this.filter.inputs[input.name] = input.value;
      }
    }

    ['map-sidebar-filter-changed', 'map-modal-filter-changed'].forEach((eventName) => {
      document.addEventListener(eventName, ((event: CustomEvent<{checkboxes: { [name: string]: string[]; },
        inputs: { [name: string]: string; }}>) => {
        this.filter = {
          ...this.filter,
          ...event.detail
        };

        this.onFilterChangedListener(this.filter);
      })  as EventListener);
    });
  }

  setMapFilter = (mapFilter: {zoom: number, center: Coordinate, extent: Extent}) => {
    this.filter.zoom = mapFilter.zoom;
    this.filter.extent = mapFilter.extent;
    this.filter.center = mapFilter.center;
  }
}